import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompoundButtonComponent } from '@apps/landing/src/app/shared/components/compound-button/compound-button.component';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { SharedModule } from '@apps/landing/src/app/shared/shared.module';
import { ButtonVariants } from '@apps/landing/src/app/shared/models/button.model';

@Component({
  selector: 'app-compound-card',
  imports: [CompoundButtonComponent, HlmButtonDirective, SharedModule],
  standalone: true,
  templateUrl: './compound-card.component.html',
})
export class CompoundCardComponent {
  @Input() containerClassName: string = '';
  @Input() sectionClassName: string = '';
  @Input() titleClassName: string = '';
  @Input() subtitleClassName: string = '';
  @Input() descriptionClassName: string = '';

  @Input() title!: string;
  @Input() subtitle?: string;
  @Input() description?: string;
  @Input() features?: string[];
  @Input() suffixInlineSvgIcon?: string;
  @Input() headerBadges?: any[];
  @Input() footerBadges?: any[];
  @Input() tableGridItems?: any;
  @Input() showHeaderButtonRight?: boolean = false;
  @Input() showHeaderButtonBottom: boolean = false;
  @Input() iconBgColor: string = '';
  @Input() showButton: boolean = false;
  @Input() buttonText: string = 'Learn More';
  @Input() buttonIcon: string = 'arrow-right';
  @Input() btnVariant: ButtonVariants = 'default';
  @Input() alwaysShowShadow: boolean = false;

  @Output() headerButtonClick = new EventEmitter<void>();
  @Output() buttonClick = new EventEmitter<void>();

  protected onHeaderButtonClick() {
    this.headerButtonClick.emit();
  }

  protected onButtonClick() {
    this.buttonClick.emit();
  }
}
